import {Directive, ElementRef, Input, OnInit, Renderer2} from '@angular/core';
import {UserColorService} from '../_services/user-color.service';
import {User} from '../_types/user';
import {backgroundByUrl} from '../_utils/background-by-url';
import {AuthService} from "../_services/auth.service";
import {Community} from "../_types/communities";
import {LocalStorageService} from "../_services/local-storage.service";

@Directive({
    selector: '[appUserAvatar]'
})
export class UserAvatarDirective implements OnInit {
    @Input({required: true, alias: 'appUserAvatar'}) user!: Partial<User>;
    currentUser: User

    constructor(private el: ElementRef, private userColorService: UserColorService, private renderer: Renderer2, private authService: AuthService,
                private localStorageService: LocalStorageService) {
        this.currentUser = this.authService.getUser();
    }

    ngOnInit(): void {
        let community: Community | null = this.localStorageService.getItem<Community | null>('lastSelectedCommunity', null);
        this.el.nativeElement.innerHTML = '';
        const span = this.renderer.createElement('span');
        // this.renderer.addClass(span, 'accent-text');
        span.innerText = (this.user?.username || this.user?.email)?.slice(0, 1)?.toUpperCase();
        this.renderer.appendChild(this.el.nativeElement, span);

        if (!this.user?.profile_picture) {
            if (community?.profile_circle_bg_color_hex) {
                this.renderer.setStyle(this.el.nativeElement, 'background-color', community.profile_circle_bg_color_hex, 1);
                if (community?.profile_circle_color_hex) {
                    this.renderer.setStyle(this.el.nativeElement, 'color', community.profile_circle_color_hex, 1);
                }
            } else {
                const color: string = this.userColorService.getUserColor(this.user?.email || this.user?.username || 'x');
                this.renderer.setStyle(this.el.nativeElement, 'background-color', color, 1);
            }
        } else {
            const url: string = this.user.profile_picture.includes('http') ? this.user.profile_picture : `https://${this.user.profile_picture}`;
            backgroundByUrl(url, this.renderer, this.el);
        }
    }
}
